// The wedding's own clock, and the formatters that render it.
//
// Split out of src/components/timeline/timelineData.js so that anything
// needing the timezone doesn't have to import that module — which pulls in
// venues.jsx and the whole venue registry with it. timelineData.js re-exports
// WEDDING_TZ, so its existing importers are unaffected.

// The schedule is about being somewhere in person, so every time is rendered
// in the wedding's timezone rather than the viewer's. A guest watching the
// livestream from abroad still wants to know when things happen *there*.
export const WEDDING_TZ = 'Africa/Addis_Ababa';

// Built once each: these run for every stream on every render of the
// Livestream page, which re-renders on every Firestore snapshot.
const DAY = new Intl.DateTimeFormat([], {
  weekday: 'short',
  day: 'numeric',
  month: 'short',
  timeZone: WEDDING_TZ,
});

const DAY_AND_TIME = new Intl.DateTimeFormat([], {
  weekday: 'short',
  day: 'numeric',
  month: 'short',
  hour: 'numeric',
  minute: '2-digit',
  timeZone: WEDDING_TZ,
});

function format(iso, formatter) {
  if (!iso) return '';
  const date = new Date(iso);
  return Number.isNaN(date.getTime()) ? '' : formatter.format(date);
}

// "Sat, 19 Sep"
export function formatWeddingDay(iso) {
  return format(iso, DAY);
}

// "Sat, 19 Sep, 3:00 PM" — the one format the admin dashboard and the guest
// page must agree on, since the whole point is that the couple see the number
// guests will see. One definition, so they can't drift.
export function formatWeddingDayAndTime(iso) {
  return format(iso, DAY_AND_TIME);
}
